import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03cecd7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photo-head" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "photo-head__title" }, " Preview ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-trash" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-trash" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "photo-body"
}
const _hoisted_8 = ["poster"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "photo-labels"
}
const _hoisted_11 = { class: "photo-labels__title" }
const _hoisted_12 = { class: "option-btn" }
const _hoisted_13 = { class: "option-btn__text" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "photo-toast"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "photo-toast__icon icon icon-check" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "photo-toast__text" }, "Autosaved", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = ["poster"]
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "photo-labels"
}
const _hoisted_22 = { class: "photo-footer" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-adjust" }, null, -1))
const _hoisted_25 = { class: "text" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-label-add" }, null, -1))
const _hoisted_27 = { class: "text" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-cam",
  style: {"font-size":"30px"}
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-plus",
  style: {"font-size":"16px"}
}, null, -1))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-cam",
  style: {"font-size":"30px"}
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-plus",
  style: {"font-size":"16px"}
}, null, -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = {
  key: 4,
  class: "photo-footer__preview"
}
const _hoisted_35 = ["src"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-check option-btn__icon" }, null, -1))
const _hoisted_37 = { class: "option-btn__text" }
const _hoisted_38 = {
  key: 3,
  class: "label-input-wrapper"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-arrow-bottom" }, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "label-input" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label-input__title" }, "Label:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cropper = _resolveComponent("cropper")!
  const _component_SplideSlide = _resolveComponent("SplideSlide")!
  const _component_Splide = _resolveComponent("Splide")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_app_take_photo_options = _resolveComponent("app-take-photo-options")!
  const _component_app_label_input = _resolveComponent("app-label-input")!

  return (_ctx.images.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["photo-wrap", {'photo-wrap-single': !_ctx.isCaseCropper}]),
        style: _normalizeStyle({ 'z-index': _ctx.zIndex })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          (!_ctx.isFlutter)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)), ["prevent"])),
                class: "delete-photo-icon-wrap"
              }, _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.isFlutter)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDeleteFlutter && _ctx.onDeleteFlutter(...args)), ["prevent"])),
                class: "delete-photo-icon-wrap"
              }, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        (_ctx.images.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_Splide, {
                class: "main-splide",
                "onSplide:active": _ctx.handleOnChange,
                ref: "main",
                options: _ctx.mainOptions
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (img, idx) => {
                    return (_openBlock(), _createBlock(_component_SplideSlide, {
                      key: img,
                      "data-idx": idx
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["cropper-box", {'cropper-box--labels': img.labels?.length}])
                        }, [
                          (img.fileType.includes('video'))
                            ? (_openBlock(), _createElementBlock("video", {
                                key: 0,
                                poster: img.poster,
                                style: {"width":"100%","height":"100%"},
                                preload: "auto",
                                controls: ""
                              }, [
                                _createElementVNode("source", {
                                  src: img.url
                                }, null, 8, _hoisted_9)
                              ], 8, _hoisted_8))
                            : _createCommentVNode("", true),
                          _withDirectives(_createVNode(_component_cropper, {
                            ref: el => { _ctx.croppers[idx] = el },
                            src: img.url,
                            "stencil-props": _ctx.isCaseCropper ? _ctx.caseStencil : _ctx.profileStencil,
                            "default-size": _ctx.defaultSize,
                            "image-restriction": "stencil",
                            class: "cropper",
                            canvas: false
                          }, null, 8, ["src", "stencil-props", "default-size"]), [
                            [_vShow, !img.fileType.includes('video')]
                          ])
                        ], 2),
                        (img.labels?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$localize('app.take.photo.all.labels')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(img.labels, (label) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: "photo-labels__item",
                                  key: label.text
                                }, _toDisplayString(label.text), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["data-idx"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["onSplide:active", "options"]),
              (_ctx.isCaseCropper)
                ? (_openBlock(), _createBlock(_component_Splide, {
                    key: 0,
                    ref: "thumbs",
                    options: _ctx.thumbOptions
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "splide__option-btn",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleCrop && _ctx.handleCrop(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["icon option-btn__icon", _ctx.hideOptionsList ? _ctx.doneBtnIcon : 'icon-dots'])
                          }, null, 2),
                          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$localize(_ctx.hideOptionsList ? _ctx.doneBtnText : 'app.take.photo.options.button')), 1)
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (slide) => {
                        return (_openBlock(), _createBlock(_component_SplideSlide, { key: slide }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: slide.fileType.includes('video') ? slide.poster : slide.url
                            }, null, 8, _hoisted_14)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["options"]))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createBlock(_component_el_carousel, {
                    onChange: _ctx.handleOnChange,
                    interval: 0,
                    key: _ctx.images.length + _ctx.counter,
                    "initial-index": _ctx.images.length - 1
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (img, idx) => {
                        return (_openBlock(), _createBlock(_component_el_carousel_item, { key: img }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["cropper-box", {'cropper-box--labels': img.labels?.length}])
                            }, [
                              (img.fileType.includes('video'))
                                ? (_openBlock(), _createElementBlock("video", {
                                    key: 0,
                                    poster: img.poster,
                                    style: {"width":"100%","height":"100%"},
                                    preload: "auto",
                                    controls: ""
                                  }, [
                                    _createElementVNode("source", {
                                      src: img.url
                                    }, null, 8, _hoisted_20)
                                  ], 8, _hoisted_19))
                                : _createCommentVNode("", true),
                              _withDirectives(_createVNode(_component_cropper, {
                                ref: el => { _ctx.croppers[idx] = el },
                                src: img.url,
                                "stencil-props": _ctx.isCaseCropper ? _ctx.caseStencil : _ctx.profileStencil,
                                "default-size": _ctx.defaultSize,
                                "image-restriction": "stencil",
                                class: "cropper",
                                canvas: false
                              }, null, 8, ["src", "stencil-props", "default-size"]), [
                                [_vShow, !img.fileType.includes('video')]
                              ])
                            ], 2),
                            (img.labels?.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createTextVNode(_toDisplayString(_ctx.$localize('app.take.photo.all.labels')) + " ", 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(img.labels, (label) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      class: "photo-labels__item",
                                      key: label.text
                                    }, _toDisplayString(label.text), 1))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["onChange", "initial-index"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_22, [
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.filesToUpload[_ctx.currentSlide]?.coodrinates?.rotate), 1))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
            class: "button button__icon button__link"
          }, [
            _hoisted_24,
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$localize('app.take.photo.adjust')), 1)
          ]),
          (!_ctx.singleUpload || _ctx.showLabels)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addLabelsOpen && _ctx.addLabelsOpen(...args)), ["prevent"])),
                class: "button button__icon button__link"
              }, [
                _hoisted_26,
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$localize('app.take.photo.labels')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isCaseCropper && !_ctx.isFlutter)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleReTake && _ctx.handleReTake(...args)), ["prevent"])),
                class: _normalizeClass([{ 'disabled': _ctx.images.length >= 20 }, "button__add button button__primary button__icon button__lg"])
              }, _hoisted_30, 2))
            : _createCommentVNode("", true),
          (_ctx.isCaseCropper && _ctx.isFlutter)
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.flutterOpenCamera && _ctx.flutterOpenCamera(...args)), ["prevent"])),
                class: _normalizeClass([{ 'disabled': _ctx.images.length >= 20 }, "button__add button button__primary button__icon button__lg"])
              }, _hoisted_33, 2))
            : _createCommentVNode("", true),
          (_ctx.images.length && !_ctx.isCaseCropper)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (slide) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: slide,
                    class: "photo-footer__preview-item"
                  }, [
                    _createElementVNode("img", {
                      src: slide.fileType.includes('video') ? slide.poster : slide.url
                    }, null, 8, _hoisted_35)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isCaseCropper)
            ? (_openBlock(), _createElementBlock("div", {
                key: 5,
                class: "photo-footer__done option-btn",
                onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleCrop && _ctx.handleCrop(...args)), ["prevent"]))
              }, [
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$localize('app.take.photo.done.button')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.showOptions)
          ? (_openBlock(), _createBlock(_component_app_take_photo_options, {
              key: 1,
              "files-to-upload": _ctx.filesToUpload,
              "hide-options-list": _ctx.hideOptionsList,
              labels: _ctx.labels,
              onOnCancel: _ctx.onOptionsClose,
              onOnDone: _ctx.onDone,
              onOnAddLabels: _ctx.addLabelsOpen,
              onOnLabelDelete: _ctx.deleteLabel,
              onMergeLabels: _ctx.handleLabelsMerge,
              onOnClose: _ctx.onCancel,
              "data-component": "app-take-photo-options"
            }, null, 8, ["files-to-upload", "hide-options-list", "labels", "onOnCancel", "onOnDone", "onOnAddLabels", "onOnLabelDelete", "onMergeLabels", "onOnClose"]))
          : _createCommentVNode("", true),
        (_ctx.showAddLabel)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancelLabelsPopup && _ctx.cancelLabelsPopup(...args))),
              style: {"position":"absolute","z-index":"1","top":"0","left":"0","width":"100%","height":"100%","background-color":"rgba(0,0,0,0.2)"}
            }))
          : _createCommentVNode("", true),
        (_ctx.showAddLabel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("span", {
                class: "label-input-close",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.cancelLabelsPopup && _ctx.cancelLabelsPopup(...args)))
              }, _hoisted_40),
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createVNode(_component_app_label_input, {
                  onOnInputDone: _ctx.addLabelsClose,
                  class: "label-input__input",
                  "show-done-control": "",
                  "is-photo": "",
                  focus: ""
                }, null, 8, ["onOnInputDone"])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 6))
    : _createCommentVNode("", true)
}